/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

const max_length = 64;

/**
 * extract Words
 * @param input the basename of a file
 * @returns {string}
 */
export function extractWords (input) {
    
    // make lowercase
    let str = input.toLowerCase();
    
    // replace all non-alphanumeric characters with a space
    str = str.replace(/[\W_]+/g,"-");
    
    // replace multiple dashes with a single dash
    str = str.replace(/--+/g, "-");
    
    // remove dash in first or last position
    str = str.replace(/^-|-$/, "");
    
    // split into tokens using - as separator 
    let tokens = str.split("-");
    
    // get first 4 tokens
    tokens = tokens.slice(0, 4);
    
    // reassemble basename
    str = tokens.join("-");
    
    // ensure the final length is shorter than 64 characters
    let basename = str.length > max_length ? str.substring(0,max_length) : str; 
    
    return basename.toLocaleLowerCase();
}
